export default __webpack_public_path__ + "static/20241128-dcc0c884e4893f51ba3646525f63474d.png";